
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/2020-01-22-understanding-component-oriented-styling-using-styletron",
      function () {
        return require("private-next-pages/articles/2020-01-22-understanding-component-oriented-styling-using-styletron.mdx");
      }
    ]);
  